import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  alert: () => __(translations.soulEater.alert, 'Alert!'),
  cancel: () => __(translations.soulEater.cancel, 'Cancel'),
  deleteConfirmation: () => __(translations.soulEater.deleteConfirmation, 'Do you really want to delete this resource?'),
  yesImSure: () => __(translations.soulEater.yesImSure, "Yes, I'm sure"),
};
